<template>
	<nav :class="navClass">
		<button v-if="showMobileBtn" :class="getMobileNavBtnClass" @click="toggleMobileNav">
			<span class="btn-menu__line"></span>
			<span class="btn-menu__line"></span>
			<span class="btn-menu__line"></span>
			<span class="label"></span>
		</button>
		<div class="nav__wrap">
			<div class="nav__report">
				<transition name="navfade">
					<div v-show="showFront" class="nav-bar">
						<div class="nav__logo">
							<Logo/>
						</div>
						<transition name="mobilenav">
							<div v-show="showMobileNav && showFront" class="nav__box">
								<ul class="nav__list" @mouseout="offHover()">
									<li 
									 v-for="(nav, index) in getReportNav" 
									 :class="getItemClass(index)" 
									 :style="getItemStyle(index)" 
									 @mouseover="onHover(index)" >
										<a :href="nav.jump" 
										   :class="getNavClass(nav)" 
										   v-html="getNavText(nav)" 
										   v-smooth-scroll="scrollProperties(-80)"
										   @focus="onFocus(index)" 
									 		 @blur="onBlur(index)"></a>
										<component v-if="nav.subnav" :is="getExpandTag" :class="getExpandClass(index)" @click="onClick(index)"><span class="hidden">Expand</span></component>
										<transition name="subnav">
											<div v-show="nav.subnav && showSubNav(index)" class="nav__subnav">
												<ul class="nav__subnav-list">
													<li v-for="subnav in nav.subnav" class="nav__item">
														<a :href="subnav.jump" class="nav__link" 
														   v-html="getNavText(subnav)" 
														   v-smooth-scroll="scrollProperties(-100)"
														   @focus="onFocus(index)" 
									 		 				 @blur="onBlur(index)"></a>
													</li>
												</ul>
											</div>
										</transition>

									</li>
								</ul>
								<div class="language-switcher"><LanguageSwitcher v-if="doLocal"/></div>
								<div :class="getSwitcherClass">
									<Button v-if="doLocal" :href="getLocalPath" :text="_translate('nav.btn.local')"></Button>
									<LanguageSwitcher v-else />
								</div>
							</div>
						</transition>
					</div>
				</transition>
			</div>
			<div class="nav-local" >
				<transition name="navfade">
					<div v-show="showBack" class="nav-bar">
						<div class="nav__logo">
							<Logo/>
						</div>
						<transition name="mobilenav">
							<div v-show="showMobileNav && showBack" class="nav__box">
								<ul class="nav__list" @mouseout="offHover()">
									<li 
									 v-for="(nav, index) in getLocalNav" 
									 :class="getItemClass(index)" 
									 :style="getItemStyle(index)" 
									 @mouseover="onHover(index)" >
										<a :href="nav.jump" 
										   :class="getNavClass(nav)" 
										   v-html="getNavText(nav)" 
										   v-smooth-scroll="scrollProperties(-80)"
										   @focus="onFocus(index)" 
									 		 @blur="onBlur(index)"></a>
										<component v-if="nav.subnav" :is="getExpandTag" :class="getExpandClass(index)" @click="onClick(index)"><span class="hidden">Expand</span></component>
										<transition name="subnav">
											<div v-show="nav.subnav && showSubNav(index)" class="nav__subnav">
												<ul class="nav__subnav-list">
													<li v-for="subnav in nav.subnav" class="nav__item">
														<a :href="subnav.jump" class="nav__link" 
														   v-html="getNavText(subnav)" 
														   v-smooth-scroll="scrollProperties(-100)"
														   @focus="onFocus(index)" 
									 		 				 @blur="onBlur(index)"></a>
													</li>
												</ul>
											</div>
										</transition>
									</li>
								</ul>
								<div class="language-switcher"><LanguageSwitcher v-if="doLocal"/></div>
								<!--<div :class="getSwitcherClass">
									<Button v-if="doLocal" href="/" type="secondary" :text="_translate('nav.btn.report')"></Button>
									<LanguageSwitcher v-else />
								</div>-->
							</div>
						</transition>
					</div>
				</transition>
			</div>
		</div>
	</nav>
</template>

<script>
	
  import Button from '@/components/Button.vue'
  import LanguageSwitcher from '@/components/LanguageSwitcher.vue'
  import Logo from '@/components/Logo.vue'

  import navigation from '@/content/navigation.js'

	export default {

		components: {
			Button,
			LanguageSwitcher,
      Logo
    },

		props: {

			localpath: {
				type: String,
				default: '/local'
			}

		},

		data: function() {

			return {
				navigation: navigation,
				subnav: false,
				blur: false,
			}

		},

		computed: {

			getReportNav: function() {

				if (this.$data.navigation.structure.report) {
					return this.$data.navigation.structure.report;
				}

				return [];

			},

			getLocalNav: function() {

				if (this.$data.navigation.structure.local) {
					return this.$data.navigation.structure.local;
				}

				return [];

			},			

			getLocalPath: function() {

				return this.localpath;

			},

			getExpandTag: function() {
				return this.$parent.isTablet ? 'button' : 'span';
			},

			getMobileNavBtnClass: function() {

				var c = 'btn-menu';
				if ( this.showBack ) {
					c += ' invert';
				}
				if ( this.$root.$data.mobnav ) {
					c += ' is-open';
				}
				return c;

			},

			getSwitcherClass: function() {

				var c = 'nav__switcher';

				if ( window.appLang === 'fr' ) {
					c += ' nav__switcher--fr';
				}

				return c;

			},

			showFront: function() {

				if ( this.doLocal) {
					return ( this.getRoute === 'report' );
				} else {
					return true;
				}

			},

			showBack: function() {

				if ( this.doLocal) {
					return ( this.getRoute !== 'report' );
				} else {
					return false;
				}

			},

			showMobileNav: function() {

				if ( ! this.isTablet ) { 
					return true;
				} else { 
					return this.$root.$data.mobnav;
				}
		
			},

			showMobileBtn: function() {

				return this.isTablet;

			},

			navClass: function() {
				
				var r = this.getRoute;

				if ( this.showFront ) { return 'nav nav--report' }
				else { return 'nav nav--local' }

				return 'nav';

			},

			scrollDuration: function() {
				var duration = 500;
				return duration;
			},	

		},

		methods: {

			getNavText: function(item) {

				var lang = window.appLang;
				return item.text[lang];
			},

			getNavClass: function(nav) {

				var c = 'nav__link';

				if ( nav.subnav ) {

					c += ' subnav';

				}

				return c;

			},			

			getItemClass: function(index) {

				var c = "nav__item";
				//Lanter if ( this.$data.subnav === index ) {
				// 	c += ' js-hover';
				// }

				return c;

			},

			getItemStyle: function(index) {

				var delay = 0 + (index*.1);
				var style = "transition-delay: " + delay + 's;'
				return style;

			},

			getExpandClass: function(index) {

				var c = "expand";
				if ( this.$data.subnav === index ) {
					c += ' js-active';
				}
				return c;

			},

			showSubNav: function(index) {
				return this.$data.subnav === index;
			},

			toggleMobileNav: function() {

				this.$root.$data.mobnav = ! this.$root.$data.mobnav;

			},

			onClick: function(index) {
				if ( this.isTablet) {
					if ( this.$data.subnav === index ) {
						this.$data.subnav = false;
					} else {
						this.$data.subnav = index;
					}
				}
			},

			onHover: function(index) {
				this.$data.blur = false;
				if ( ! this.isTablet ) {
					this.$data.subnav = index;
				}
			},

			onFocus: function(index) {
				this.$data.blur = false;
				if ( ! this.isTablet ) {
					this.$data.subnav = index;
				}				
			},

			onBlur: function(index) {
				var self = this;
				this.$data.blur = setTimeout(function(){
					if ( self.$data.blur ) {
						self.$data.subnav = false;
					}
				},10);
			},	

			offHover: function() {
				var self = this;
				this.$data.blur = setTimeout(function(){
					if ( self.$data.blur ) {
						// if ( ! this.isTablet ) {
						self.$data.subnav = false;
					}
				},10);
			},

			scrollProperties: function(offset) {

				return {
					duration: this.scrollDuration,
					offset: offset,
					updateHistory: true
				}

			},			

		}

	}

</script>

<style lang="scss">

	$switcher-width: 15rem;
	$switcher-width-tab: 12rem;

	$lang-width: 7rem;
	$lang-width-tab: 6rem;

	.nav {
		perspective: 2000px;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 10;
	}

	
	/**
	 * Nav Flipper
	 */
	.nav.nav--local .nav__wrap {
		transform: rotateX(180deg);

		.nav-local {
			backface-visibility: visible;
			-ms-backface-visibility: visible;
		}
	}

	.nav, .nav__report, .nav-local {

		width: 100%;
		@include mq('lap') {
			height: $nav-height;
		}

	}

	/* flip speed goes here */
	.nav__wrap {
		transition: transform .6s ease;
		transform-style: preserve-3d;

		position: relative;
		transform-origin: 100% 28px;

		@include mq('lap') {
			transform-origin: 100% #{$nav-height/2};
		}
	}

	/* hide back of pane during swap */
	.nav__report, .nav-local {
		backface-visibility: hidden;
		-ms-backface-visibility: hidden;

		position: absolute;
		top: 0;
		left: 0;

		display: flex;
		justify-content: center;
		align-items: center;

	}	

	/* nav__report pane, placed above back */
	.nav__report {
		z-index: 2;
		background: $red;
	  /* for firefox 31 */
		transform: rotateX(0deg);
	}

	/* back, initially hidden panel */
	.nav-local {
		background: $mist;
		transform: rotateX(180deg);
		z-index: 2;

		.nav__item {
			.expand {
				&::before {
					border-color: $grey;
				}
			}
		}

		.nav__link {

			&:link,
			&:visited {
				color: $black;
				text-decoration: none;
			}

			&:hover,
			&:focus {
				background-color: $mist-darker;
			}


		}

		.nav__box {
			background: $mist;
			@include mq('lap') {
				background: none;
			}
		}

		.nav__subnav-list {
			background: $white;
			@include mq('lap') {
				background: $white;
				box-shadow: inset 0 5px 5px -5px rgba($black, .3);
			}			
		}

		.logo-wrap{

			svg {
				background: $red;
			}
		}

	}

	/* variable class applied to entire nave by the Vue app */
	.nav--local {
		.btn-menu__line {
			background-color: $grey-dark;
		}
	}

	.nav-bar {
		width: 100%;
		display: flex;
		align-items: center;

	}

	.nav__logo {

		height: 100%;
		width: 100%;
		box-shadow: $box-shadow;
		position: relative;
		z-index: 2;

		@include mq('lap') {
			position: static;
			box-shadow: none;
			width: auto;
		}

		.logo-wrap {
			width: 198px;
		}

	}

	.nav__box {

		position: absolute;
		left: 0;
		right: 0;
		top: 100%;
		background-color: $red;
		padding-top: 1rem;
		height: calc(100vh - 58px);
    overflow: auto;
    -webkit-overflow-scrolling: touch;

		@include mq('lap') {

			position: static;
			left: auto;
			right: auto;
			top: auto;
			background: none;
			padding-top: 0;

			display: flex;
			justify-content: space-between;
			width: calc(100% - 198px);
			height: auto;
			overflow: visible;

			.nav__switcher {
				width: $switcher-width-tab;
			}

			.nav__switcher--fr {
				width: $switcher-width-tab + 2rem;
			}

			.language-switcher {
				width: $lang-width-tab;
			}

			.nav__list {
				width: calc(100% - (#{$switcher-width-tab} + #{$lang-width-tab}));

				@include mq('desk') {
					width: calc(100% - (#{$switcher-width} + #{$lang-width}));
				}
			}

		}

    @include mq('desk') {
			.nav__switcher {
				width: $switcher-width;
			}
			.language-switcher {
				width: $lang-width;
			}

    }	

    @include mq('wide') {

			.nav__switcher {
				width: $switcher-width * 1.25;
			}

    	.language-switcher {
    		width: $lang-width * 1.5;
    	}

    }	

	}

	.nav__list {

		list-style-type: none;
		padding: 0;
		width: 100%;
		margin: 0;

		@include mq('lap') {
			display: flex;
			align-items: center;
			padding-left: 0rem;
		}

		@include mq('desk') {
			padding-left: 2.5rem;
		}

		> .nav__item {

			@include mq('lap') {

				position: relative;
				margin-right: 0rem;
				// white-space: nowrap;

			}

			@include mq('desk') {
				margin-right: 1rem;
			}

			@include mq('wide') {
				margin-right: 1.5rem;
			}

			// &.js-hover,
			// &.js-open {

			// 	.nav__subnav {

			// 		max-height: 20rem;
			// 		opacity: 1;

			// 	}

			// }			

			.nav__link {

				@include mq('lap') {
					display: flex;
					align-items: center;
					height: $nav-height;
				}

			}

		}


	}

	.nav__subnav {
		background: $red-dark;
	}

	.nav__subnav-list {

		list-style-type: none;
		padding: 1px 0;
		margin: 0;

		@include mq('lap') {
			position: absolute;
			left: 50%;
			top: 100%;
			transform: translate3d(-50%, 0, 0);
			max-width: calc(100% + 12rem);
			min-width: 100%;
			background: $red;

			box-shadow: inset 0 5px 5px -5px rgba($red-dark, .3);
		}

		> .nav__item {
			margin: 0;

			&:first-child { margin-top: .5rem;}
			&:last-child { margin-bottom: .5rem;}

			.nav__link {

				padding-left: 4rem;

				@include mq('lap') {

					padding-left: 0;
					white-space: nowrap;
					padding: .75rem 1.25rem;
					display: block;
					height: auto;
					text-align: left;

				}

			}	

		}

	}

	.nav__switcher,
	.language-switcher {

		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		padding-left: 2.25rem;

		@include mq('lap') {
			align-items: center;
			justify-content: center;
			padding-left: 0;
		}

	}

	.nav__switcher {

		margin-bottom: 2rem;
		@include mq('lap') {
			margin-bottom: 0;
		}

	}

	.language-switcher {

		margin-bottom: 1rem;
		@include mq('lap') {
			margin-bottom: 0;
		}
		
	}	

	.nav__item {

		position: relative;
		transition: transform .5s ease;

		@include mq('lap') {
			display: flex;
			align-items: center;			
			transition: none;
		}

		.expand {

			border: none;
			appearance: none;
			background: none;			

			position: absolute;
			right: 1.25rem;
			top: .65rem;
			margin-left: .75rem;
			width: 2rem;
			height: 2rem;

			@include mq('lap') {
				position: absolute;
				top: calc(50% - .65rem);
				right: 0;
				width: 1rem;
				height: 1rem;	
			}

			&::before {

				content: '';
				display: block;
				border: 0;
				border-top: 0;
				border-left: 0;
				border-right: 2px solid $white;
				border-bottom: 2px solid $white;
				transform: rotate(45deg);
				transform-origin: center;
				display: inline-block;
				width: 8px;
				height: 8px;
				padding: 0;
				outline: none;
				position: relative;
				top: -4px;

				transition: top .3s ease, transform .3s ease;
				cursor: pointer;

				@include mq('lap') {

					width: 6px;
					height: 6px;
					border-right: 1px solid $white;
					border-bottom: 1px solid $white;
					cursor: default;

				}

			}

			&.js-active {
	
				top: .65rem;

				@include mq('lap') {
					top: calc(50% - .65rem);
				}

				&::before {
					transform: rotate(-135deg);
					// top: 2px;

					@include mq('lap') {
						// top: -2px;
					}
				}

			}

			.hidden {

				visibility: hidden;
				font-size: 0;
				opacity: 0;

			}

		}

	}

	.nav__link {

		@include typesize('extra-small');
		padding: 1rem 1.5rem 1rem 2.25rem;
		display: block;
		width: 100%;
		outline: none;

		@include mq('lap') {
			padding: 0 1.5rem 0 1rem;
			display: inline;
			flex: auto;
			text-align: right;
			font-size: .82em;

			&.subnav {
					padding: 0 2rem 0 1rem;
			}

		}

		@include mq('desk') {
			@include typesize('extra-small');
		}

		&:link,
		&:visited {
			color: $white;
			text-decoration: none;
		}

		&:hover,
		&:focus {
			background-color: $red-dark;
		}

	}

	.btn-menu {
		position: absolute;
		z-index: 11;
		top: .65rem;
		right: .5rem;
		width:2.5rem;
		height:2.5rem;
		padding:0;
		background: none;
		border:none;
		color:$white;
		cursor:pointer;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: .25rem;
		outline: none;

		transition: top .3s ease;

		// &.invert {
		// 	.btn-menu__line {
		// 		background-color: $black;
		// 	}
		// }

		&.is-open {

			.btn-menu__line:nth-child(1) { width: 1.85rem; transform:rotate(45deg) translate3d(15%, 170%, 0); }
			.btn-menu__line:nth-child(2) { width: 0; opacity: .65; transform:rotate(-45deg) translate3d(0, 0, 0); }
			.btn-menu__line:nth-child(3) { width: 1.85rem; transform:rotate(-45deg) translate3d(15%, -170%, 0); }

			.label {

				.label__menu {

					height: 0;
					opacity: 0;

				}

				.label__close {

					height: 1em;
					opacity: 1;

				}

			}

		}

		.label {

			font-size: .5rem;
			text-transform: uppercase;
			letter-spacing: .1em; 
			margin-top: .25rem;
			flex-direction: column;
			opacity: 1;
			display: none;

			@include mq('tab') {
				display: flex;
			}

			span {

				overflow: hidden;
				height: 1em;
				transition: height .3s ease, opacity .3s ease;
				display: inline-block;

			}

			.label__close {

				height: 0;
				opacity: 0;

			}

		}
	}	

	.btn-menu__line {
		display: block;
		width: 1.35rem;
		height: 3px;
		border-radius: 5px;
		background-color: $white;
		margin: 2px 0;
		transform: rotate(0) translate3d(0, -2px, 0);
		transition: transform 0.2s ease-in-out, background-color 0.2s ease-in-out;

		&:nth-child(2) { transform: rotate(0) translate3d(0, 0, 0); transform-origin:top left; }
		&:nth-child(3) { transform: rotate(0) translate3d(0, 2px, 0); transform-origin:center center; }
		&:nth-child(4) { transform-origin:bottom right; }
	}	

</style>

